var React = require('react');

function DiscDrive (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 96a160 160 0 1 0 160 160A160 160 0 0 0 256 96zm0 192a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M496 416h-16V96a64 64 0 0 0-64-64H96a64 64 0 0 0-64 64v320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-240 0a160 160 0 1 1 160-160 160 160 0 0 1-160 160z","className":"fa-primary","key":2})]);
}

DiscDrive.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = DiscDrive;

DiscDrive.default = DiscDrive;
